<template>
    <sign-in-page
        :credentials="data"
        :errors="errors"
        :wait="wait"
        @update:email="data.email = $event"
        @update:password="data.password = $event"
        @submit="signIn"
    />
</template>

<script>
import { publicPages } from '../../config/variant'

export default {
    name: 'SignInController',
    components: {
        SignInPage: publicPages.signIn,
    },
    data () {
        return {
            data: {
                email: '',
                password: '',
            },
            errors: {
                email: [],
                password: [],
            },
            wait: false,
        }
    },
    methods: {
        signIn () {
            this.wait = true

            this.$axios.post('/manager/sign-in', this.data)
                .then(res => {
                    if (res.data.success) {
                        this.$axios.defaults.headers.common['Authorization'] = res.data.data
                        this.$store.commit('updateToken', res.data.data)
                        this.$router.push('/')
                    } else {
                        this.errors.email = res.data.errors.email || []
                        this.errors.password = res.data.errors.password || []
                    }

                    this.wait = false
                })
                .catch(() => {
                    this.wait = false
                })
        },
    },
}
</script>

<style scoped>
</style>
